import { useResolveUploadedPath, useTrans } from "../hooks";
import {
    Avatar,
    Badge,
    Box,
    Button,
    Divider,
    HStack,
    Popover,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
    Text,
    useDisclosure,
    VStack,
} from "@chakra-ui/react";
import { AppIcon } from "./AppIcon";
import { NavItem } from "../containers";
import AppNavItem from "../containers/AppNav/AppNavItem";
import { User } from "../apis";
import { APPC } from "../config";

interface AppUserNavProps {
    user: User;
    navItems: NavItem[];
}

export const AppUserNav = ({ user, navItems }: AppUserNavProps) => {
    const { t } = useTrans();
    const { isOpen, onOpen, onClose } = useDisclosure();
    return (
        <HStack gap={1}>
            <Avatar
                size={"sm"}
                name={user?.fullName}
                src={useResolveUploadedPath(
                    APPC.BE.Upload.FILETYPE.FILETYPE_USER_AVATAR,
                    user?.imageName
                )}
                color={"var(--chakra-colors-primaryS10)"}
                bgColor={"var(--chakra-colors-primaryT80)"}
            />
            <Popover
                placement="bottom-end"
                offset={[0, 15]}
                isOpen={isOpen}
                onClose={onClose}
                onOpen={onOpen}
            >
                <PopoverTrigger>
                    <Button
                        size={"sm"}
                        className={"btn-icon-header"}
                        variant={"transparent"}
                    >
                        <AppIcon
                            name={"icl-chevron-bottom-alt"}
                            w="1rem"
                            color={"var(--chakra-colors-primary)"}
                        />
                    </Button>
                </PopoverTrigger>
                <PopoverContent>
                    <PopoverBody>
                        {isOpen && (
                            <VStack
                                gap={1}
                                py={1}
                                ps={1}
                                alignItems={"stretch"}
                                justify={"start"}
                            >
                                <HStack gap={3} px={4} pb={2}>
                                    <Avatar
                                        size={"lg"}
                                        name={user?.fullName}
                                        src={useResolveUploadedPath(
                                            APPC.BE.Upload.FILETYPE
                                                .FILETYPE_USER_AVATAR,
                                            user?.imageName
                                        )}
                                        color={
                                            "var(--chakra-colors-primaryS10)"
                                        }
                                        bgColor={
                                            "var(--chakra-colors-primaryT80)"
                                        }
                                    />
                                    <Box>
                                        <Text
                                            textStyle={"heading5"}
                                            noOfLines={2}
                                            wordBreak="break-word"
                                        >
                                            {user?.fullName}
                                        </Text>
                                        <Text
                                            textStyle={"regularSm"}
                                            noOfLines={2}
                                            wordBreak="break-word"
                                            color={
                                                "var(--chakra-colors-contentT40)"
                                            }
                                        >
                                            {user.email}
                                        </Text>
                                        <Badge variant={"outline"} size={"sm"}>
                                            {t(
                                                `con.User:USERTYPE_${user?.userType}`
                                            )}
                                        </Badge>
                                    </Box>
                                </HStack>
                                <Divider
                                    mb={2}
                                    borderColor={
                                        "var(--chakra-colors-primaryT80)"
                                    }
                                />
                                {navItems?.map((item, index) => (
                                    <AppNavItem
                                        key={index}
                                        navItem={item}
                                        variant={"transparent"}
                                    />
                                ))}
                            </VStack>
                        )}
                    </PopoverBody>
                </PopoverContent>
            </Popover>
        </HStack>
    );
};
